import { render, staticRenderFns } from "./DeanAdmissionStudentView.vue?vue&type=template&id=2dd7fa8b"
import script from "./DeanAdmissionStudentView.vue?vue&type=script&lang=js"
export * from "./DeanAdmissionStudentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports